module.exports = __webpack_public_path__ + "img/banner_m.78901cac.jpg";